import React from "react";
import { CircularProgress, Button } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

/**
 * PrimaryButtonUkoBeMyself constant ( function component used as generic primary button )
 *
 * @exports constant
 * @param {*} { ...props }
 * @returns HTML object
 */

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "Center",
    width: "100%",
  },
  button: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.buttonUko.buttonUkoBackgroundActive,
    width: "100%",
    height: "40.19px",
    justifyContent: theme.buttonUko.buttonJustifyContent,
    color: theme.buttonUko.buttonUkoBackgroundSuccess,
    fontSize: "20px",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: theme.buttonUko.buttonUkoBackgroundActive,
    },
    "& .MuiButton-label": {
      fontFamily: theme.fontFamilyApp,
      fontSize: theme.buttonUko.buttonFontSize,
      fontWeight: 600,
      color: theme.buttonUko.buttonUkoBackgroundSuccess,
      textTransform: "none",
    },
  },
  buttonDisabled: {
    marginRight: theme.spacing(2),
    width: "100%",
    height: "40.19px",
    justifyContent: theme.buttonUko.buttonJustifyContent,
    fontSize: "20px",
    borderRadius: "10px",
    backgroundColor: theme.buttonUko.buttonUkoBackgroundDisabled,
    color: theme.buttonUko.buttonUkoColorDisabled,
    fontWeight: "bold",
    "& .MuiButton-label": {
      fontFamily: theme.fontFamilyApp,
      fontSize: theme.buttonUko.buttonFontSize,
      fontWeight: 600,
      textTransform: "none",
      textAlign: theme.buttonUko.buttonTextAling,
    },
  },
  isAnotherButtonDisabled: {
    marginRight: theme.spacing(2),
    width: "100%",
    height: "40.19px",
    justifyContent: theme.buttonUko.buttonJustifyContent,
    fontSize: "20px",
    borderRadius: "10px",
    backgroundColor: theme.buttonUko.buttonUkoBackgroundDisabled,
    color: theme.buttonUko.buttonUkoColorDisabledResetPwd,
    fontWeight: "bold",
    "& .MuiButton-label": {
      position: 'relative', 
      fontFamily: theme.fontFamilyApp,
      fontSize: theme.buttonUko.buttonFontSize,
      fontWeight: 600,
      textTransform: "none",
      paddingLeft: 5
    },
  },
}));
const PrimaryButtonUkoBeMyself = ({ ...props }) => {
  const { txtBtn, onClick, type, loading, name, disabled, href, isAnotherButtonDisabled } = props;
  const theme = useTheme();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Button
        href={href}
        name={name}
        type={type === "" || type === undefined ? "submit" : type}
        className={loading || disabled ? isAnotherButtonDisabled ? classes.isAnotherButtonDisabled : classes.buttonDisabled : classes.button}
        onClick={onClick}
        disabled={loading || disabled}
        endIcon={(theme?.buttonUko?.buttonEndIcon === 'true')
          ? <ChevronRightIcon
              style={{
                marginRight: 10
              }}
            />
          : <></>}
      >
        {loading && <CircularProgress size={14} color="secondary" />}
        {!loading && txtBtn}
      </Button>
    </div>
  );
};

export default PrimaryButtonUkoBeMyself;
